import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mb-pdf-preview',
  templateUrl: './pdf-preview.component.html',
  styleUrls: ['./pdf-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class PdfPreviewComponent {
  private sanitizer = inject(DomSanitizer);

  @Input()
  set url(v: any) {
    const x = this.sanitizer.bypassSecurityTrustResourceUrl(v);
    this._url = x;
  }
  get url() {
    return this._url;
  }

  @Input() title!: string;

  private _url!: SafeResourceUrl;
}
